import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Table, Input, Breadcrumb, Button, Space, Row, Tooltip } from "antd";
import { ReactComponent as Editicon } from "../../../image/Editicon.svg";
import { ReactComponent as Invoice } from "../../../image/Invoice.svg";
import PlusSquareOutlined from "../../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../../image/SearchIcon.svg";
import { ErrorNotificationMsg } from "../../../utils/Notifications";
import { debounce } from "lodash";
import { getRequest } from "../../../axios";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import { DownloadOutlined } from "@ant-design/icons";

const PurchasedSubscriptionList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Search } = Input;
  // const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [purchasedSubscriptionList, setPurchasedSubscriptionList] = useState(
    []
  );
  const [totalCount, settotalCount] = useState(0);
  // const [reload, setReload] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10
  });

  useEffect(() => {
    const getPurchasedSubscriptionList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest("payment-subscription/", state);

        if (apiResponse.status) {
          setPurchasedSubscriptionList(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_purchased_subscription_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getPurchasedSubscriptionList();
  }, [state, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company__name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company__name";
    }
    if (sortField === "subscription_name" && sortOrder === "ascend") {
      sortingEnumKey = "subscription__package_name";
    }
    if (sortField === "subscription_name" && sortOrder === "descend") {
      sortingEnumKey = "-subscription__package_name";
    }

    if (sortField === "payment_mode" && sortOrder === "ascend") {
      sortingEnumKey = "payment_mode";
    }
    if (sortField === "payment_mode" && sortOrder === "descend") {
      sortingEnumKey = "-payment_mode";
    }

    if (sortField === "payment_reference_id" && sortOrder === "ascend") {
      sortingEnumKey = "payment_reference_id";
    }
    if (sortField === "payment_reference_id" && sortOrder === "descend") {
      sortingEnumKey = "-payment_reference_id";
    }

    if (sortField === "start_date" && sortOrder === "ascend") {
      sortingEnumKey = "start_date";
    }
    if (sortField === "start_date" && sortOrder === "descend") {
      sortingEnumKey = "-start_date";
    }

    if (sortField === "end_date" && sortOrder === "ascend") {
      sortingEnumKey = "end_date";
    }
    if (sortField === "end_date" && sortOrder === "descend") {
      sortingEnumKey = "-end_date";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
      if (value) {
          setState({
              ...state,
              search: value,
          });
      } else {
          const { search, ...newState } = state; // Remove 'search' key from state
          setState(newState);
      }
  };

  // const rowSelection = {
  //   onChange: (selectedRowKeys) => {
  //     setSelectedRow(selectedRowKeys);
  //   },
  // };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  // const handleArchive = async (id = "") => {
  //   let ids = selectedRow;
  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   try {
  //     let apiResponse = await postRequest("subscription-delete/", {
  //       deleted: ids,
  //     });
  //     if (apiResponse.data.success) {
  //       SuccessNotificationMsg("Purchased subscription archive successfully");
  //       setReload(!reload);
  //       setSelectedRow([]);
  //     } else {
  //       ErrorNotificationMsg("Error in delete Purchased subscription");
  //     }
  //   } catch (error) {
  //     ErrorNotificationMsg(error);
  //   }
  // };
  const handleDownload = async (id, companyId) => {
    window.open(
      `payment-subscription-pdf/${id}/${companyId}`,
      "_blank"
    );
  };
  const columns = [
    {
      title: "Company",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Subscription",
      dataIndex: "subscription_name",
      key: "subscription_name",
      sorter: true,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
    },
    {
      title: "Duration (days)",
      dataIndex: "duration",
      key: "duration",
      sorter: true,
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: true,
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: true,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 80,
      render: (text, record) => {
        console.log('record', record);
        
        return (
        <Space>
          {/* <Link
            to={{
              pathname: "/purchased-subscription/edit/" + btoa(record.id),
            }}
          >
            {authUserData()?.permission.includes(
              "subcription|change_stripecharge"
            ) && <Editicon />}
          </Link> */}

          {/* <Popconfirm
            className="action"
            title={t("pop_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleArchive(record.id)}
          >
            <Archive style={{ cursor: "pointer" }}/>          </Popconfirm> */}
             <DownloadOutlined 
                        onClick={() => handleDownload(record.id, record.company)} 
          
                        />
          {/* <span>Invoice</span> */}
        </Space>
      )},
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Stay informed and in control of your subscription payments with our Payment Details feature,
                  providing transparency and convenience in managing your subscription.

                </span>
              }
            >
              <h3>{t("purchasedSubscriptionList")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("purchasedSubscription")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
              <Search
  value={searchText}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    debounceLoadData(value, onSearch);
  }}
  allowClear
  onSearch={(value) => {
    setSearchText(value);
    onSearch(value);
  }}
  prefix={
    <img
      src={SearchIcon}
      alt="SearchIcon"
      className="SearchIcon"
      width={22}
    />
  }
  placeholder={t("pl_search_list")}
  style={{ width: 250 }}
/>
              </Space>
            </div>
            {authUserData()?.permission.includes(
              "subcription|add_stripecharge"
            ) && (
                <Tooltip
                  color={colors}
                  placement="right"
                  title={
                    <span style={{ color: "#fff" }}>
                      Add a new subscription plan with detailed information on features, pricing, and billing cycles.

                    </span>
                  }
                >
                  <Button
                    className="BlueShadowBtn"
                    type="primary"
                    onClick={() => navigate("/purchased-subscription/add")}
                    icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
                  >
                    {t("addSubscription")}
                  </Button>
                </Tooltip>
              )}
          </Space>
          {/* {authUserData()?.permission.includes(
            "subcription|add_stripecharge"
          ) && (
            <Button
              className="BlueShadowBtn"
              type="primary"
              onClick={() => navigate("/purchased-subscription/add")}
              icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
            >
              {t("addSubscription")}
            </Button>
          )} */}
        </div>
      </div>

      <section className="grid-sec tablegridsec">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("purchasedSubscriptionList")}</h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
          </Col> */}
          </Row>
          {/* {selectedRow.length > 0 && (
        <Popconfirm
          className="action"
          title={t("pop_title")}
          okText={t("pop_ok")}
          cancelText={t("pop_cancel")}
          placement="left"
          onConfirm={() => handleArchive()}
        >
          <ButtonField
            type="primary"
            htmlType="button"
            label={t("pl_archive")}
          />
        </Popconfirm>
      )}
      <Tooltip placement="topLeft" title="Archived Records">
        <Link to="/purchased-subscription/archived">
          <Archiveicon />
        </Link>
      </Tooltip> */}
<div className="tablewrp">
          <Table
            scroll={{
              x: 'auto',
            }}
            // rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={purchasedSubscriptionList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};
export default PurchasedSubscriptionList;
